import React, { createContext, useContext } from "react";

// Chart/note tabs live in the app shell so a patient chart or a note editor can open from any page.
// openChart({ uuid, name, intent }) — adds/focuses a chart tab.
// openNote({ noteId, name, chartUuid, fromLabel }) — adds/focuses a standalone note-editor tab.
// openAddPatient({ prefill:{first,last}, focus:"first"|"dob" }) — opens the single Add patient tab.
export const ChartTabsContext = createContext({ openChart: null, openNote: null, openAddPatient: null, openNewVisit: null, openChartTab: null });

export function useChartTabs() {
  return useContext(ChartTabsContext);
}
